import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../../../ui/dialog';
import { Button } from '../../../ui/button';

interface MissingPromptsModalProps {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  versionNumber: string;
  missingDimensions: Array<{ id: string; name: string }>;
}

const MissingPromptsModal: React.FC<MissingPromptsModalProps> = ({
  open,
  onOpenChange,
  versionNumber,
  missingDimensions,
}) => {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[480px]">
        <DialogHeader>
          <DialogTitle>Cannot Deploy v{versionNumber}</DialogTitle>
          <DialogDescription>
            The following dimensions do not have live prompts. Each dimension
            needs a deployed prompt before the taxonomy can go live.
          </DialogDescription>
        </DialogHeader>

        <ul className="py-2 space-y-1.5">
          {missingDimensions.map((d) => (
            <li
              key={d.id}
              className="flex items-center gap-2 rounded-md border px-3 py-2 text-sm"
            >
              <span className="font-medium">{d.name}</span>
              <span className="text-xs text-muted-foreground font-mono">{d.id}</span>
            </li>
          ))}
        </ul>

        <p className="text-xs text-muted-foreground">
          Go to Prompt Management to create and deploy prompts for these dimensions.
        </p>

        <DialogFooter>
          <Button variant="outline" onClick={() => onOpenChange(false)}>
            Close
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default MissingPromptsModal;
